import PropTypes from 'prop-types';
import React from 'react';

import * as ArchiveActions from 'archive/ArchiveActions';
import {EXPENDED_PURPOSE} from 'archive/ArchiveConstants';
import ArchiveButton from 'archive/components/buttons/ArchiveButton';
import isArchived from 'archive/isArchived';
import * as SampleConstants from 'constants/SampleConstants';
import PrintLabelButton from 'label-printing/PrintLabelButton';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {requestFetchManagedModel} from 'models/ManagedModelUtil';
import StorableStore from 'samples/StorableStore';
import Tooltip from 'ui-library/bs/Tooltip';
import {ButtonStyle} from 'ui-library/buttons/Button';

function mapStorableStoreToProps(
  storableStore: typeof StorableStore,
  {containerIds}: BaseTableContainerActionButtonsProps
): ConnectedProps {
  return {
    containers: containerIds
      .map((containerId) => storableStore.getContainer(containerId))
      .filter((container) => Boolean(container)) as Array<SampleConstants.Container>,
  };
}

interface BaseTableContainerActionButtonsProps {
  containerIds: Array<string>;
  shouldShowArchiveButton?: boolean;
}

interface ConnectedProps {
  containers: Array<SampleConstants.Container>;
}

class TableContainerActionButtons extends React.Component<
  BaseTableContainerActionButtonsProps & ConnectedProps
> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    containerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    containers: PropTypes.arrayOf(SampleConstants.CONTAINER_SHAPE),
    shouldShowArchiveButton: PropTypes.bool,
  };

  override componentDidMount(): void {
    this.props.containerIds.forEach((id) => {
      requestFetchManagedModel(ManagedModelType.CONTAINER, id);
    });
  }

  override componentDidUpdate(): void {
    this.props.containerIds.forEach((id) => {
      requestFetchManagedModel(ManagedModelType.CONTAINER, id);
    });
  }

  override render(): JSX.Element {
    const {containers, shouldShowArchiveButton} = this.props;
    const isPrintButtonDisabled = !containers.length;
    const isArchiveButtonDisabled =
      !containers.length ||
      containers.some((container) => isArchived(container) || !container.permissions.archivable);
    const archiveDisabledTooltipTitle = containers.length
      ? 'Select unarchived containers to archive'
      : 'No containers selected to archive';
    return (
      <div>
        <Tooltip title="No containers selected for printing labels" disabled={!isPrintButtonDisabled}>
          <span>
            <PrintLabelButton
              buttonStyle={ButtonStyle.TERTIARY_BLUE}
              className="u-mini-spacing-right"
              disabled={isPrintButtonDisabled}
              itemIds={containers.map((container) => container.id)}
            />
          </span>
        </Tooltip>
        {shouldShowArchiveButton && (
          <Tooltip title={archiveDisabledTooltipTitle} disabled={!isArchiveButtonDisabled}>
            <span>
              <ArchiveButton
                disabled={isArchiveButtonDisabled}
                initialPurpose={EXPENDED_PURPOSE}
                items={containers}
                onArchive={ArchiveActions.bulkArchiveStorablesWithDataMods}
                tooltipTitle="Archive containers"
              />
            </span>
          </Tooltip>
        )}
      </div>
    );
  }
}

export default StorableStore.connect(mapStorableStoreToProps)(TableContainerActionButtons);
